import {destandard} from '../utils/commonFunctions';

export default function reducer(state = {
  list: [],
  file: {},
  paging: {
    current_page: 1,
    per_page: 20,
  },
  fetching: false,
  fetched: false
}, action) {
  switch (action.type) {
    case 'GET_FILES_PENDING':
    case 'GET_FILE_PENDING': {
      return {
        ...state,
        list: [],
        fetching: true,
        fetched: false
      };
    }
    case 'GET_FILES_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        list: action.payLoad.data,
        paging: destandard(action.payLoad.meta)
      };
    }
    case 'GET_FILE_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        file: action.payLoad.data,
      };
    }
    case 'DELETE_FILE_FULFILLED': {
      const newState = {...state};
      newState.list = newState.list.filter(file => file.id !== action.payLoad);
      return newState;
    }
    case 'GET_FILES_REJECTED':
    case 'GET_FILE_REJECTED': {
      return {
        ...state,
        errors: action.payLoad.errors
      };
    }
    default:
  }

  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/filesReducer.js